import axios from 'axios'
import { DateTime } from 'luxon'

import environment from '@/environment'
import type {
  EditProductionPlanObligationFormData,
  ProductionPlanObligationPeriod,
} from '@/features/portfolioHierarchy/types'

export const GET_PRODUCTION_PLAN_OBLIGATION_PERIOD_API = 'GET_PRODUCTION_PLAN_OBLIGATION_PERIOD'
export const TIMEZONE_STOCKHOLM = 'Europe/Stockholm'

export const getProductionPlanObligationPeriod = async (
  countryCode: string,
  regulationObjectCode: string,
): Promise<ProductionPlanObligationPeriod> => {
  const response = await axios.get<ProductionPlanObligationPeriod>(
    `${environment.services.productionPlanApiUrl}/obligation-periods/${countryCode}/${regulationObjectCode}`,
  )
  return response.data
}

export const updateProductionPlanObligationPeriod = async (obligationPeriod: EditProductionPlanObligationFormData) => {
  // Convert dates to Stockholm timezone start-of-day, then to UTC
  const convertToStockholmStartOfDayUTC = (date: DateTime | null | undefined): string | null => {
    if (!date?.isValid) return null

    const stockholmDateTime = DateTime.fromObject(
      {
        year: date.year,
        month: date.month,
        day: date.day,
        hour: 0,
        minute: 0,
        second: 0,
        millisecond: 0,
      },
      { zone: TIMEZONE_STOCKHOLM },
    )

    return stockholmDateTime.toUTC().toISO()
  }

  const obligationStartAt = convertToStockholmStartOfDayUTC(obligationPeriod.obligationPeriod?.startAt)
  const obligationEndAt = convertToStockholmStartOfDayUTC(obligationPeriod.obligationPeriod?.endAt)

  const url = `${environment.services.productionPlanApiUrl}/obligation-periods/${obligationPeriod.countryCode}/${obligationPeriod.regulationObjectCode}`
  const params: Record<string, string | null> = {
    obligationStartAt,
    obligationEndAt,
  }

  if (obligationPeriod.productionPlanName) {
    params.productionPlanName = obligationPeriod.productionPlanName
  }

  const response = await axios.put<ProductionPlanObligationPeriod>(url, null, { params })

  return response.data
}
